import { CTACard } from '@/components/CTACard';

import Repair from '@/public/img/strapi/technician-repairing.webp';

type RepairCTAProps = {
	testId?: string;
	showImage: boolean;
};

const RepairCTA = (props: RepairCTAProps) => {
	const { testId = 'RepairCTA', showImage } = props;
	return (
		<CTACard
			testId={testId}
			type="link"
			compact
			color="amber"
			href="/repair/"
			isStrapiInlineComponent
		>
			{showImage && (
				<div className="hidden h-44 w-60 overflow-hidden rounded-l-3xl lg:flex xl:w-70">
					<CTACard.Image
						src={Repair}
						alt="HVAC.com Repairs"
						className="min-h-full object-cover"
					/>
				</div>
			)}
			<div className="flex-1 px-6 py-4">
				<CTACard.Badge color="amber" compact className="mb-2">
					HVAC.com Repairs
				</CTACard.Badge>
				<CTACard.Title compact className="pb-0.5">
					Repair your HVAC
				</CTACard.Title>
				<CTACard.Content compact isStrapiInlineComponent className="pb-2">
					Get your HVAC system repaired by a qualified technician.
				</CTACard.Content>
				<CTACard.Action color="amber" compact>
					See how it works
				</CTACard.Action>
			</div>
		</CTACard>
	);
};

export default RepairCTA;
